export default {
	// vi-VN.js
	security: {
		securityBind: "Liên kết bảo mật",
		securitySettings: "Cài đặt bảo mật",
		level: "Trung bình",
		confirm: "Xác nhận",
		submitting: "Đang gửi...",
		add: "Thêm",
		change: "Thay đổi",
		success: "Cập nhật thành công",
		select: "Chọn",

		birthday: "Ngày sinh",
		birthdayDesc: "Thêm ngày sinh để liên lạc dễ dàng.",
		month: "Tháng",
		day: "Ngày",
		year: "Năm",
		birthdayRequired: "Bắt buộc",
		invalidBirthday: "Không hợp lệ",
		invalidMonth: "Tháng sai",
		invalidDay: "Ngày sai",
		invalidYear: "Năm sai",
		updateBirthdayFail: "Cập nhật thất bại",
		birthdayVerify: "Xác minh ngày sinh",
		birthdayVerifyDesc: "Tăng bảo mật",

		email: "Email",
		emailDesc: "Dùng để bảo mật",
		emailRequired: "Bắt buộc",
		emailInvalid: "Sai email",
		updateEmailFail: "Thất bại",
		emailVerify: "Xác minh email",
		emailVerifyDesc: "Tăng bảo mật",

		phone: "Số điện thoại",
		bindPhone: "Thêm số",
		phoneDesc: "Bảo mật tài khoản",
		phoneRequired: "Bắt buộc",
		phoneUsed: "Dùng số khác",
		updatePhoneFail: "Thất bại",
		noCode: "Chưa nhận mã?",
		smsHelp: "Nếu thử nhiều lần:",
		smsTips1: "1. Kiểm tra số",
		smsTips2: "2. Số còn hoạt động",
		smsTips3: "3. Kiểm tra SMS",
		smsTips4: "4. Có thể trễ",
		phoneVerify: "Xác minh số",
		phoneVerifyDesc: "Tăng bảo mật",

		setPassword: "Đặt mật khẩu",
		passwordDesc: "Mật khẩu đăng nhập",
		clickSelectBirthday: "Nhấp để chọn ngày sinh",
		selectBirthday: "Chọn ngày sinh",
		confirm: "Xác nhận",
		cancel: "Hủy",
		withdrawPassword: "Mật khẩu rút tiền",
		withdrawpasswordDesc: "Thiết lập mật khẩu rút tiền của bạn.",
		set: "Thiết lập",
	},

	contactPhone: {
		title: "Thay đổi số điện thoại",
		titleMobile: "Thay đổi",
		description: "Thêm số điện thoại liên hệ để giao tiếp dễ dàng hơn. Thông tin cá nhân của bạn sẽ được bảo vệ.",
		label: "Số điện thoại liên hệ",
		confirm: "Xác nhận",
		submitting: "Đang gửi...",
		required: "Số điện thoại là bắt buộc",
		invalid: "Số điện thoại không hợp lệ",
		success: "Cập nhật số điện thoại thành công!",
		updateFailed: "Cập nhật thất bại",
		tryAgain: "Cập nhật thất bại, vui lòng thử lại sau",
		verifyTitleMobile: "Xác minh Số điện thoại",
		titleMobile: "Liên kết Số điện thoại",
		changeTitleMobile: "Thay đổi Số điện thoại",
		securityTip: "Số điện thoại bảo mật tài khoản. Chỉ bạn mới có thể liên kết.",
		placeholder: "Số điện thoại",
		noCodeReceived: "Không nhận được mã?",
		codeDescription: "Nhập mã xác minh gồm 6 chữ số được gửi đến chi tiết liên hệ của bạn bên dưới:",
		resendIn: "Gửi lại sau {countdown} giây",
		resend: "Gửi lại",
		submitting: "Đang gửi...",
		confirm: "Xác nhận",
		invalidCode: "Vui lòng nhập mã 6 chữ số hợp lệ",
		required: "Vui lòng nhập số điện thoại",
		invalid: "Vui lòng nhập số điện thoại hợp lệ",
		success: "Cập nhật thành công",
		updateFailed: "Cập nhật thất bại",
		tryAgain: "Vui lòng thử lại sau"
	},

	contactEmail: {
		title: "Thay đổi Email",
		titleMobile: "Thay đổi",
		description: "Thêm email liên hệ để giao tiếp dễ dàng hơn. Thông tin cá nhân của bạn sẽ được bảo vệ.",
		label: "Email liên hệ",
		placeholder: "Email",
		confirm: "Xác nhận",
		submitting: "Đang gửi...",
		required: "Email không được để trống",
		invalid: "Vui lòng nhập địa chỉ email hợp lệ",
		success: "Cập nhật email thành công!",
		updateFailed: "Cập nhật thất bại",
		tryAgain: "Cập nhật thất bại, vui lòng thử lại sau",
		verifyTitleMobile: "Xác minh Email",
		titleMobile: "Liên kết Email",
		changeTitleMobile: "Thay đổi Email",
		securityTip: "Email bảo mật tài khoản. Chỉ bạn mới có thể liên kết.",
		noCodeReceived: "Không nhận được mã?",
		codeDescription: "Nhập mã xác minh gồm 6 chữ số được gửi đến chi tiết liên hệ của bạn bên dưới:",
		resendIn: "Gửi lại sau {countdown} giây",
		resend: "Gửi lại",
		submitting: "Đang gửi...",
		confirm: "Xác nhận",
		invalidCode: "Vui lòng nhập mã 6 chữ số hợp lệ",
		required: "Vui lòng nhập email",
		invalid: "Vui lòng nhập địa chỉ email hợp lệ",
		success: "Cập nhật thành công",
		updateFailed: "Cập nhật thất bại",
		tryAgain: "Vui lòng thử lại sau"
	},

	accountInfo: {
		profileInfo: "Thông tin hồ sơ",
		contactInfo: "Thông tin liên hệ",
		privacy: "Quyền riêng tư",
		contactEmail: "Email liên hệ",
		contactPhone: "Số điện thoại liên hệ",
		addEmailDesc: "Thêm email liên hệ để giao tiếp dễ dàng hơn. Thông tin cá nhân của bạn sẽ được bảo vệ.",
		addPhoneDesc: "Thêm số điện thoại liên hệ để giao tiếp dễ dàng hơn. Thông tin cá nhân của bạn sẽ được bảo vệ.",
		hideUsername: "Ẩn tên người dùng của tôi khỏi danh sách công khai",
		add: "Thêm",
		change: "Thay đổi",
		idLabel: "ID: ",
		vip: "VIP ",
		player: "NGƯỜI CHƠI",
		copied: "Đã sao chép!",
		hideSuccess: "Đã ẩn tên người dùng",
		showSuccess: "Đã hiển thị tên người dùng",
		operationFailed: "Thao tác thất bại",
		editProfile: "Chỉnh Sửa Hồ Sơ",
		contactInfo: "Thông Tin Liên Hệ",
		contactEmail: "Email Liên Hệ",
		emailTip: "Thêm email liên hệ để tiện giao tiếp. Thông tin cá nhân của bạn sẽ được bảo vệ.",
		change: "Thay đổi",
		addEmail: "Thêm Email",
		contactPhone: "Số Điện Thoại Liên Hệ",
		phoneTip: "Thêm số điện thoại của bạn để xác minh tài khoản an toàn.",
		addPhone: "Thêm Số Điện Thoại",
		birthdayBind: "Xác minh liên kết ngày sinh",
		birthdayTip: "Liên kết ngày sinh của bạn để nâng cao tính bảo mật cho tài khoản.",
		addBirthday: "Thêm Ngày Sinh",
		personalInfo: "Thông Tin Cá Nhân",
		personalTip: "Xác minh danh tính của bạn để mở khóa nhiều dịch vụ hơn. Dữ liệu của bạn được an toàn.",
		verifyNow: "Xác Minh Ngay",
		hideUsernameTip: "Khi được bật, người dùng khác sẽ không thể nhìn thấy tên người dùng của bạn trong danh sách công khai.",
	},

	kyc: {
		title: "Xác minh danh tính",
		verifyIdentity: "Xác minh danh tính của bạn",
		completeDesc: "Hoàn tất xác minh danh tính để bảo mật tài khoản và mở khóa tất cả tính năng.",
		failed: "Xác minh thất bại. Vui lòng thử lại.",
		reVerify: "Xác minh lại",
		checkYouOut: "Hãy xác minh danh tính của bạn",
		prepareDoc: "Chuẩn bị giấy tờ của bạn",
		prepareDocDesc: "Chuẩn bị sẵn giấy tờ tùy thân hợp lệ.",
		useSmartphone: "Sử dụng điện thoại thông minh",
		useSmartphoneDesc: "Bạn cần điện thoại thông minh để hoàn tất xác minh.",
		scanQr: "Quét mã QR",
		scanQrDesc: "Quét mã QR bằng điện thoại của bạn để tiếp tục trên thiết bị di động.",
		noSmartphone: "Không có điện thoại thông minh?",
		completeOnMobile: "Hoàn tất trên di động"
	},

	verify: {
		title: "Xác minh",
		personalVerification: "Xác minh cá nhân",
		weak: "Yếu",
		level1: "Cấp 1",
		personalInfo: "Thông tin cá nhân",
		personalInfoDesc: "Hoàn thành thông tin cá nhân để tăng cường bảo mật tài khoản.",
		verifyNow: "Xác minh ngay",
		level2: "Cấp 2",
		kycVerification: "Xác minh KYC",
		kycDesc: "Hoàn tất xác minh KYC để mở khóa hạn mức cao hơn và quyền truy cập đầy đủ.",
		docTip: "Vui lòng đảm bảo giấy tờ của bạn rõ ràng và hợp lệ trước khi gửi."
	},

	personalInfo: {
		verify: "Xác minh",
		completeInfo: "Hoàn thành thông tin của bạn",
		completeInfoDesc: "Điền thông tin cá nhân để hoàn tất xác minh.",
		firstName: "Tên",
		paternalSurname: "Họ cha",
		maternalSurname: "Họ mẹ",
		contactNumber: "Số liên hệ",
		phoneUsed: "Số điện thoại này đã được sử dụng.",
		contactEmail: "Email liên hệ",
		invalidEmail: "Địa chỉ email không hợp lệ.",
		detailedAddress: "Địa chỉ chi tiết",
		city: "Thành phố",
		street: "Đường",
		neighborhood: "Khu phố",
		houseNumber: "Số nhà",
		postalCode: "Mã bưu điện",
		save: "Lưu",
		male: "Nam",
		female: "Nữ"
	},

	withdrawPassword: {
		changeTitle: "Đổi mật khẩu rút tiền",
		setTitle: "Đặt mật khẩu rút tiền",
		changeDesc: "Nhập mật khẩu cũ và đặt mật khẩu rút tiền mới.",
		setDesc: "Đặt mật khẩu rút tiền để bảo vệ tiền của bạn.",
		oldPlaceholder: "Mật khẩu rút tiền cũ",
		newPlaceholder: "Mật khẩu rút tiền mới",
		confirmPlaceholder: "Xác nhận mật khẩu rút tiền"
	},

	contactBirthday: {
		title: "Ngày sinh liên hệ",
		desc: "Thêm ngày sinh liên hệ để giao tiếp dễ dàng hơn. Thông tin cá nhân của bạn sẽ được bảo vệ.",
		label: "Ngày sinh liên hệ",
		invalid: "Ngày sinh không hợp lệ."
	},

	changePassword: {
		title: "Đổi mật khẩu",
		expiredDesc: "Mật khẩu của bạn đã hết hạn. Vui lòng đặt mật khẩu mới để tiếp tục.",
		verifyOldDesc: "Nhập mật khẩu cũ và đặt mật khẩu mới.",
		passwordPlaceholder: "Mật khẩu cũ",
		newPlaceholder: "Mật khẩu mới",
		confirmPlaceholder: "Xác nhận mật khẩu mới",
		lengthError: "Mật khẩu phải có từ 6 đến 30 ký tự.",
		sameAsOld: "Mật khẩu mới không được trùng với mật khẩu cũ.",
		confirmRequired: "Vui lòng xác nhận mật khẩu mới của bạn.",
		notMatch: "Mật khẩu không khớp.",
		success: "Đổi mật khẩu thành công",
		failed: "Đổi mật khẩu thất bại"
	},

	settingsNav: {
		title: "Cài đặt",
		accountInfo: "Thông tin tài khoản",
		security: "Bảo mật"
	},

	verificationBirthday: {
		title: "Ngày sinh",
		securityTip: "Ngày sinh bảo mật tài khoản. Chỉ bạn mới có thể liên kết.",
		clickSelectBirthday: "Nhấp để chọn ngày sinh",
		invalidBirthday: "Ngày sinh không hợp lệ",
		submitting: "Đang gửi...",
		confirm: "Xác nhận",
		cancel: "Hủy",
		selectBirthday: "Chọn Ngày sinh",
		birthdayRequired: "Vui lòng nhập ngày sinh",
		updateBirthdayFail: "Cập nhật ngày sinh thất bại",
		success: "Cập nhật thành công"
	}
};